import '../Styles/About.css';

const About = () => {
  return (
		<section id='about' className="about-section">
			<span className='about-span'></span>
			<div className='about-title'>
				<h1>About me</h1>
			</div>
      <p>
			{/* I am a bussiness woman with a great passion for technology and development. I find joy in algorithoms and problem solving. */}
			I am a passionate software developer with an extensive background in Sales and Customer service. 
			With the ability to solve problems and to communicate with non-technical clients in a way they can understand. 
			I find joy in both working in teams and tackling independent tasks.
			Quality User Experience and development design are one of my many passions. 
			You will usually find me Sailing, Climbing, reading books, at the gym or behind my computer coding.

      </p>
    </section>
  )
}

export default About